"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LegalProvider_1 = require("./LegalProvider");
exports.default = LegalProvider_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/services/LegalProvider/index.js
// module id = 1176
// module chunks = 8